<form novalidate (ngSubmit)="createToken()" [formGroup]="stripeTest">
    <input class="formControl" placeholder="Nombre" formControlName="name" type="text" style="margin-bottom: 15px;" />
    <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions" style="margin-bottom: 15px;"></ngx-stripe-card>
    <button type="submit" class="btn btnPrimary btn-lg cl-white width-100" style="margin-top: 20px;">Guardar</button>
</form>